<div class="agreements-section">
  <div class="agreements-header">
    <strong>{{ 'Legalization.AssignToAgreements' | translate }}</strong>
  </div>
  <hr>
    <mat-checkbox [checked]="showOnlyActiveAgreements"
      (change)="onShowOnlyActiveAgreementsChange($event)"
      [disabled]="disabled">
      <strong>{{ 'Legalization.ShowOnlyActiveAgreements' | translate }}</strong>
    </mat-checkbox>
    <section class="agreements-grid">
      @for (agreement of listOfAgreements$ | async; track agreement) {
        <div class="grid-row">
          <div class="select-column">
            <mat-checkbox
              [value]="agreement.LegalizationId"
              [checked]="isAgreementSelected(agreement.LegalizationId)"
              (change)="onAgreementToggle(agreement.LegalizationId, $event)"
              [disabled]="disabled || isGivenAgreementDisabled(agreement.LegalizationId)">
            </mat-checkbox>
          </div>
          <div class="company-column"
            [matTooltip]="agreement.CompanyName"
            matTooltipPosition="above">
            {{ agreement.CompanyName }}
          </div>
          <div class="employer-column"
            [matTooltip]="agreement.EmployerName"
            matTooltipPosition="above">
            {{ agreement.EmployerName }}
          </div>
          @if (agreement.EmploymentDateFrom || agreement.EmploymentDateTo) {
            <div class="dates-column"
              [matTooltip]="(agreement.EmploymentDateFrom | date : 'dd.MM.yyyy') + ' - ' + (agreement.EmploymentDateTo | date : 'dd.MM.yyyy')"
              matTooltipPosition="above">
              {{ agreement.EmploymentDateFrom | date : 'dd.MM.yyyy' }} - {{ agreement.EmploymentDateTo | date : 'dd.MM.yyyy' }}
            </div>
          }
        </div>
      }
    </section>
  </div>
